import { addDoc } from "firebase/firestore";
import { CommentType } from "../types";
import { commentsCollection } from "../../../lib/firebase/firestore";

export const addComment = async (comment: CommentType) => {
  return addDoc(commentsCollection, comment);
};
